export const sliderItems = [
  {
    id: 1,
    img: "https://www.benq.com/content/dam/b2c/en-ap/gaming-bash/2021-mobiuz-2021-165hz-series/ex2710r.png",
    title: "SUMMER SALE",
    desc: "ENHANCE YOUR GAMING EXPERIENCE FLAT 30% OFF ON ALL GAMING MONITORS",
    bg: "f1f2f6",
  },
  {
    id: 2,
    img: "https://resource.logitechg.com/w_1200,c_limit,q_auto,f_auto,dpr_auto/d_transparent.gif/content/dam/gaming/en/products/pro-x-superlight/pro-x-superlight-black-hero.png?v=1",
    title: "GPRO SUPERLIGHT",
    desc: "DESIGNED WITH AND FOR PROS, NOW SHIPPING TO INDIA",
    bg: "bdc3c7",
  },
  {
    id: 3,
    img: "https://www.reactionstoattractions.com/wp-content/uploads/2020/10/series-x.png",
    title: "XBOX SERIES-X",
    desc: "XBOX SERIES X NOW AT JUST ₹45,000",
    bg: "dcdde1",
  },
];
export const categories = [
  {
    id: 1,
    img: "https://mms.businesswire.com/media/20211116006191/en/927263/5/G_Eclipse_KV_Main.jpg",
    title: "SHROUD GAMING SERIES",
  },
  {
    id: 2,
    img: "http://cdn.home-designing.com/wp-content/uploads/2020/09/botanical-home-workspace.jpg",
    title: "WANNA BUILD A PC? SHOP HERE AT DISCOUNTED RATES",
  },
];

export const categoriesTab = [
  {
    id: 1,
    img: "https://cdn.vox-cdn.com/thumbor/onNc9cWjFs5du3Uu83gG2azPB2A=/0x0:2400x1600/1200x800/filters:focal(1008x608:1392x992)/cdn.vox-cdn.com/uploads/chorus_image/image/68973950/k65rgbminilede.0.jpg",
    title: "KEYBOARDS",
    cat: "keyboards",
  },{
    id: 2,
    img: "https://cdn.pocket-lint.com/r/s/1200x/assets/images/148341-laptops-news-lg-reveals-the-worlds-first-one-millisecond-g-sync-compatible-ips-gaming-monitor-image1-cmypzvj5ow.jpg",
    title: "MONITORS",
    cat: "monitors",
  },{
    id: 3,
    img: "https://images.frandroid.com/wp-content/uploads/2021/10/deepcool-mc310-04-1200x800.jpg",
    title: "GAMING MICE",
    cat: "mouse",
  },
  {
    id: 4,
    img: "https://cdn.vox-cdn.com/thumbor/L2P_IKa0dOuK3jE16WC8q1LjaQE=/0x0:2040x1360/1200x800/filters:focal(857x517:1183x843)/cdn.vox-cdn.com/uploads/chorus_image/image/69047506/beoplayportallede.0.jpg",
    title: "HEADPHONES",
    cat: "headphones",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://preview.redd.it/miyaqob3npy51.jpg?width=1800&format=pjpg&auto=webp&s=edadfc8590962fbfefd744a3f37c56c3efe0c5fb",
  },
  {
    id: 2,
    img: "https://quadrastores.com/uploads/product_image/product_4963_4.jpg",
  },
  {
    id: 3,
    img: "https://techmartunbox.com/wp-content/uploads/2021/01/rz01-03420100-r3m1-image-1-600x600-1.jpg",
  },
  {
    id: 4,
    img: "https://i.pinimg.com/736x/23/e2/91/23e2914b55daaa789a6f2ba0bec43f79.jpg",
  },
  {
    id: 5,
    img: "http://xboxlimited.com/image/cache/catalog/products/xboxseriess1_600x600-600x600.jpg",
  },
  {
    id: 6,
    img: "https://preview.redd.it/jx5qrlfdyg161.jpg?width=1800&format=pjpg&auto=webp&s=1b811a88a960bc7f05ce2b42c24b44f476b6a467",
  },
  {
    id: 7,
    img: "https://i.pinimg.com/originals/c6/2d/c4/c62dc40de0806f395da7fd10de38a9c7.jpg",
  },
  {
    id: 8,
    img: "http://cdn.mos.cms.futurecdn.net/gjqqfHS9f59Ed9nWk4xH7g.jpg",
  },
  {
    id: 9,
    img: "https://techmartunbox.com/wp-content/uploads/2021/01/rz01-03420100-r3m1-image-2-600x600-1.jpg",
  },
  {
    id: 10,
    img: "https://cdn.shopify.com/s/files/1/0223/8994/8491/products/IMG_5857_Edited_1800x1800.jpg?v=1600237328",
  },
  {
    id: 11,
    img: "https://cdn.shopify.com/s/files/1/1473/3902/products/00.jpg?v=1632454108",
  },
  {
    id: 12,
    img: "https://cdn.shopify.com/s/files/1/0059/0630/1017/products/Keychron-Q1-QMK-Custom-Mechanical-Keyboard----2_1800x1800.jpg?v=1628590107",
  },
  {
    id: 13,
    img: "https://ae01.alicdn.com/kf/H5f292334d3594de8a17175e2ec9c4881G.jpg",
  },
  {
    id: 14,
    img: "https://ae01.alicdn.com/kf/Hd21a7d9439c34f0daab2f34ebef6d7e9c.jpg",
  },
  {
    id: 15,
    img: "https://i.redd.it/nx2jxvqvylb61.jpg",
  },
];
